import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';

import { IDashBoardAdminChartDetailsWithProvider } from '../dasboard-admin-chart-details.model';
import { ListValue } from '../list/list-value.model';

@Component({
    moduleId: module.id,
    selector: 'todays-top-campaign-views',
    templateUrl: 'todays-top-campaign-views.component.html'
})
export class TodaysTopCampaignViewsComponent implements OnChanges {
    @Input() data: IDashBoardAdminChartDetailsWithProvider;
    @Input() dataForToday: IDashBoardAdminChartDetailsWithProvider;
    @Input() showTopSectionOverlay: boolean;
    title: string = "Today's top";
    subTitle: string = "Ads";
    displayName: string = "Brand";
    displayValue: string = "Views";
    items: ListValue[] = new Array<ListValue>();

    private mapAllData(): void {
        for (let item of this.data.topCampaignViews) {
            this.items.push(new ListValue(item.campaignName, item.views))
        }
    }

    private mapTodayData(): void {
        this.items.splice(0);
        for (let item of this.dataForToday.topCampaignViews) {
            this.items.push(new ListValue(item.campaignName, item.views))
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && this.items.length == 0)
            this.mapAllData();
        if (this.dataForToday)
            this.mapTodayData();
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/todaystopcampaign/todays-top-campaign-views.component.ts